module.exports = __webpack_public_path__ + "img/motor_no49.6c421e49.jpg";